/**
 * `<pickup-availability>` custom element (FR2).
 *
 * Re-renders the pickup availability for the newly selected variant by
 * fetching the standalone `pickup-availability` section via the Section
 * Rendering API and swapping the content in place.
 */
class PickupAvailability extends HTMLElement {
  connectedCallback() {
    document.addEventListener('shopify:product:select', this.onVariantChange.bind(this));
  }

  onVariantChange(event) {
    const variant = event.variant;
    if (!variant || !variant.id) return;
    if (String(variant.id) === this.dataset.variantId) return;

    const url = `${window.location.pathname}?variant=${variant.id}&section_id=pickup-availability`;
    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const updated = doc.querySelector('[data-pickup-availability]');
        if (updated) {
          this.innerHTML = updated.innerHTML;
          this.dataset.variantId = String(variant.id);
        }
      })
      .catch(() => {});
  }
}

if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', PickupAvailability);
}
